import React from "react";
import { tableStyle } from "../ticketModule/variables/ListingVariables";
import { Table } from "../../components/CustomPaginations";
import { UserConsumer } from "../../UserContext";

const SpRoleHoursTable = (props) => {
	return (
		<UserConsumer>
			{(userDetails) => {
				return (
					<>
						<Table
							inputValue={""}
							keyField={"token"}
							columns={props.columns}
							items={props.tabledata}
							tableStyle={tableStyle}
							onTablePageChange={props.handleTableChange}
							defaultSorted={props.defaultSorted}
							showFeedback={false}
							tableLoader={props.isLoading}
							SearchBar={() => {
								return null;
							}}
							receiveData={(PageSize) => {
								props.receiveData(PageSize);
							}}
							loading={props.isLoading}
							flag={props.flag}
							totalHours={props.totalHours}
						/>
					</>
				);
			}}
		</UserConsumer>
	);
};

export default SpRoleHoursTable;
